var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83317 4.99935V2.49935C5.83317 2.03912 6.20627 1.66602 6.6665 1.66602H16.6665C17.1267 1.66602 17.4998 2.03912 17.4998 2.49935V14.166C17.4998 14.6263 17.1267 14.9993 16.6665 14.9993H14.1665V17.4986C14.1665 17.9593 13.7916 18.3327 13.3275 18.3327H3.33888C2.87549 18.3327 2.5 17.9622 2.5 17.4986L2.50217 5.83341C2.50225 5.37277 2.8772 4.99935 3.34118 4.99935H5.83317ZM4.16868 6.66601L4.16682 16.666H12.4998V6.66601H4.16868ZM7.49983 4.99935H14.1665V13.3327H15.8332V3.33268H7.49983V4.99935Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconWhite);
export default __webpack_public_path__ + "static/media/copy-icon-white.12a35fbe179dd8e649118c61624558a3.svg";
export { ForwardRef as ReactComponent };